"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getENV = getENV;

var _sharify = require("sharify");

function getENV(ENV_VAR) {
  var envVar;

  if (typeof window === "undefined") {
    envVar = process.env[ENV_VAR];
  } else {
    envVar = _sharify.data[ENV_VAR];
  }

  return envVar;
}
//# sourceMappingURL=getENV.js.map